<div class="tracking-page-search-widget-container">
  <pdq-card variant="popover" color="white">
    <form [formGroup]="formGroup">
      <div class="card" [formGroupName]="'settings'">
        <ng-container [formGroupName]="'searchPage'">
          <div class="header-container">
            <pdq-heading element="h5">Search page</pdq-heading>
            <pdq-button
              [style.color]="'var(--on-surface-light)'"
              [active]="previewButtonState"
              variant="secondary"
              size="medium"
              label="Preview"
              secondaryIcon="side_right_arrow"
              (onClick)="previewSearchPageClicked($event)">
            </pdq-button>
          </div>
          <pdq-divider></pdq-divider>
          <!-- Main content inside the card -->
          <div class="card__content">
            <div class="search-input-and-alignment">
              <pdq-input label="Search page title" formControlName="title"> </pdq-input>
            </div>

            <!-- Order and tracking number input placeholder text -->
            <pdq-input label="Tracking Input Field Placeholder" formControlName="inputPlaceholder"> </pdq-input>

            <!-- Button Text -->
            <pdq-input
              label="Button label"
              formControlName="buttonText"
              [invalid]="formGroup?.get('buttonText')?.hasError('required')"
              [invalidMsg]="'Required'">
            </pdq-input>

            <div class="tracking-page-privacy-settings">
              <h3>Privacy Settings</h3>
              <p>
                Require customers to verify their identity before viewing tracking details.<br />
                Customers must always enter an order or tracking number.<br />Add extra verification if needed.
              </p>
            </div>

            <pdq-dropdown
              [options]="dropdownOptions"
              [defaultOption]="defaultOptionDropdown"
              [useOverlay]="true"
              [overlayPositions]="
                (formGroup.get('settings')?.get('searchPage')?.get('verificationStrategy')?.value &&
                  formGroup.get('settings')?.get('searchPage')?.get('verificationStrategy')?.value ===
                    VerificationStrategy.EMAIL_AND_PHONE) ||
                formGroup.get('settings')?.get('searchPage')?.get('verificationStrategy')?.value ===
                  VerificationStrategy.EMAIL_OR_PHONE
                  ? [
                      {
                        originX: 'start',
                        originY: 'bottom',
                        overlayX: 'start',
                        overlayY: 'top',
                      },
                    ]
                  : [
                      {
                        originX: 'start',
                        originY: 'top',
                        overlayX: 'start',
                        overlayY: 'bottom',
                      },
                    ]
              "
              (onChange)="applyVerificationMode($event?.value)"></pdq-dropdown>

            <!-- Email input placeholder text -->
            @if (
              formGroup.get('settings')?.get('searchPage')?.get('verificationStrategy')?.value ===
                VerificationStrategy.EMAIL_ONLY ||
              formGroup.get('settings')?.get('searchPage')?.get('verificationStrategy')?.value ===
                VerificationStrategy.EMAIL_AND_PHONE ||
              formGroup.get('settings')?.get('searchPage')?.get('verificationStrategy')?.value ===
                VerificationStrategy.EMAIL_OR_PHONE
            ) {
              <pdq-input label="Email Field Placeholder" formControlName="emailPlaceholder"> </pdq-input>
            }

            <!-- Phone number input placeholder text -->
            @if (
              formGroup.get('settings')?.get('searchPage')?.get('verificationStrategy')?.value ===
                VerificationStrategy.PHONE_ONLY ||
              formGroup.get('settings')?.get('searchPage')?.get('verificationStrategy')?.value ===
                VerificationStrategy.EMAIL_AND_PHONE ||
              formGroup.get('settings')?.get('searchPage')?.get('verificationStrategy')?.value ===
                VerificationStrategy.EMAIL_OR_PHONE
            ) {
              <pdq-input label="Phone Number Field Placeholder" formControlName="phonePlaceholder"> </pdq-input>
            }
          </div>
        </ng-container>
      </div>
    </form>
  </pdq-card>
</div>
